import type { ComponentProps } from 'react';

import { clsxm } from '@vs-shop/utils';

export const IconExclamationTriangle = ({ className, ...props }: ComponentProps<'svg'>) => (
  <svg
    data-slot="icon-exclamation-triangle"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 20 17"
    fill="none"
    className={clsxm('h-[17px] w-5', className)}
    {...props}
  >
    <path
      d="M9.53137 1.9975L17.0614 15.0075H2.00137L9.53137 1.9975ZM0.271371 14.0075C-0.498629 15.3375 0.461371 17.0075 2.00137 17.0075H17.0614C18.6014 17.0075 19.5614 15.3375 18.7914 14.0075L11.2614 0.9975C10.4914 -0.3325 8.57137 -0.3325 7.80137 0.9975L0.271371 14.0075ZM8.53137 7.0075V9.0075C8.53137 9.5575 8.98137 10.0075 9.53137 10.0075C10.0814 10.0075 10.5314 9.5575 10.5314 9.0075V7.0075C10.5314 6.4575 10.0814 6.0075 9.53137 6.0075C8.98137 6.0075 8.53137 6.4575 8.53137 7.0075ZM8.53137 12.0075H10.5314V14.0075H8.53137V12.0075Z"
      fill="currentColor"
    />
  </svg>
);
